import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { CLIENT_GROUPS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const Partner = () => {
  const { lang, t } = useLang();
  return (
    <section data-testid="partner-section" className="relative bg-cream text-forest py-20 sm:py-28">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-gold-2 mb-10">
            {t("partner.clientsTitle")}
          </p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-px bg-forest/10 border border-forest/10">
          {CLIENT_GROUPS.map((g, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.1 }}
              className="bg-cream p-8 lg:p-10"
              data-testid={`client-group-${i}`}
            >
              <h3 className="font-display text-2xl font-medium text-forest-deep mb-6">{g[lang].title}</h3>
              <ul className="space-y-3">
                {g.items.map((item) => (
                  <li key={item} className="flex gap-3 text-sm text-forest/75 leading-snug">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-gold-2 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partner;
